module.exports = __webpack_public_path__ + "static/media/pic03.f7092f61.jpg";